import { usePageSeo } from "@/hooks/usePageSeo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const PrivacyPolicyPage = () => {
  usePageSeo("privacy");
  const { getSetting } = useSiteSettings();
  const company = getSetting("site_title", "World Transfers Trips");
  const email = getSetting("email", "info@worldtransferstrips.com");

  return (
    <main className="min-h-screen bg-background">
      <section className="relative h-[40vh] flex items-end overflow-hidden bg-primary">
        <Navbar />
        <div className="container mx-auto px-4 relative z-10 pb-12 pt-24">
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-primary-foreground">Privacy Policy</h1>
          <p className="text-primary-foreground/60 mt-2 font-sans">Last updated: March 9, 2026</p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-secondary" />
      </section>

      <section className="py-16 md:py-24 bg-background">
        <div className="container mx-auto px-4 max-w-3xl prose prose-neutral dark:prose-invert">
          <h2>1. Introduction</h2>
          <p>{company} ("we", "us", or "our") operates a transportation booking platform. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.</p>

          <h2>2. Information We Collect</h2>
          <h3>Personal Data</h3>
          <p>When you make a booking or contact us, we may collect:</p>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Pickup and drop-off locations</li>
            <li>Flight information</li>
            <li>Payment details (processed securely by third-party providers)</li>
          </ul>
          <h3>Automatically Collected Data</h3>
          <ul>
            <li>IP address and browser type</li>
            <li>Device information</li>
            <li>Pages visited and time spent</li>
            <li>Cookies and similar technologies (see our Cookie Policy)</li>
          </ul>

          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>To process and manage your bookings</li>
            <li>To communicate with you about your reservations</li>
            <li>To send booking confirmations and receipts</li>
            <li>To improve our services and website</li>
            <li>To comply with legal obligations</li>
          </ul>

          <h2>4. Sharing of Information</h2>
          <p>We do not sell your personal data. We may share information with:</p>
          <ul>
            <li>Transportation service providers (drivers) to fulfill your booking</li>
            <li>Payment processors for secure transactions</li>
            <li>Legal authorities when required by law</li>
          </ul>

          <h2>5. Data Security</h2>
          <p>We implement industry-standard security measures to protect your personal information. However, no electronic transmission or storage method is 100% secure.</p>

          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Withdraw consent at any time</li>
          </ul>

          <h2>7. Data Retention</h2>
          <p>We retain your personal data for as long as necessary to fulfill the purposes outlined in this policy, or as required by law.</p>

          <h2>8. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated revision date.</p>

          <h2>9. Contact Us</h2>
          <p>If you have questions about this Privacy Policy, please contact us at <a href={`mailto:${email}`} className="text-secondary hover:underline">{email}</a>.</p>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default PrivacyPolicyPage;
